import moment from 'moment';
import {isString, isNumber} from 'lodash';
import {reverseDate, reverseShortDate} from '../common/constants/datesFormat';
import {REPORT_HEADERS} from './fileHeaders';

const ENABLED_HEADERS = true;

function quantityFormat(number, initialZeros = 4, endZeros = 2) {
  if (number === null) {
    const initial = ''.padStart(initialZeros, '0');
    const end = ''.padEnd(endZeros, '0');
    return `${initial}.${end}`;
  }
  const numberToSring = String(number);
  const split = numberToSring.split('.');
  const initial = split[0].padStart(initialZeros, '0');
  let end = ''.padEnd(endZeros, '0');
  if (split.length === 2) {
    end = split[1].padEnd(endZeros, '0');
    return `${initial}.${end}`;
  }
  return `${initial}.${end}`;
}

function entireNumberFormat(number, initialZeros = 6) {
  number = Math.trunc(number);
  if (number === null) {
    return ''.padStart(initialZeros, '0');
  }
  const numberToString = String(number);
  const initial = numberToString.padStart(initialZeros, '0');
  return `${initial}`;
}

function ruleThreeFormat(number, initialZeros = 6, endZeros = 4) {
  if (number === null || number === '0' || number === 0) {
    return '';
  }
  return quantityFormat(number, initialZeros, endZeros);
}

function transformDate(date) {
  if (date && date.trim() !== '' && moment(date).isValid) {
    return moment(date).format(reverseDate);
  }
  return '';
}

/* eslint-disable camelcase, max-statements, max-len*/
function createDetail(items) {
  let result = ENABLED_HEADERS ? `${REPORT_HEADERS}\n` : '';
  if (items.length > 0) {
    items.forEach(
      ({
        receive,
        distCode,
        twcNo,
        initialProcessDate,
        page,
        claimantCode,
        franchise,
        warrantyType,
        dataId,
        nonVFlag,
        operationType,
        processDate,
        processFlag,
        invoiceNo,
        dealerCode,
        dealerClaimNo,
        currency,
        exchangeRate,
        prr1,
        LaborRate,
        t1Code,
        t2Code,
        wmi,
        vds,
        cd,
        vis,

        t3_1,
        t3_2,
        t3_3,
        t3_4,
        t3_5,
        t3_6,
        t3_7,

        repairOpenDate,
        repairCompletionDate,
        deliveryDate,
        mileage,
        km,
        repairOrderNo,
        previousRepairOrderNo,
        previousRepairCompletionDate,

        accFstInsDate,
        accFstInsMileage,
        previousRepairMileage,
        previousInvoiceNo,
        currentInvoiceNo,

        amountPartTotal,
        laborHourTotal,
        amountLaborTotal,
        amountSubletTotal,
        amountGrantTotal,

        part,
        labor,
        sublet,

        ofpLocalFlag,
        ofp,

        payCode1,
        localFlag1,
        partno1,
        qty1,
        partAmount1,
        multiprr1,
        payCode2,
        localFlag2,
        partno2,
        qty2,
        partAmount2,
        multiprr2,
        payCode3,
        localFlag3,
        partno3,
        qty3,
        partAmount3,
        multiprr3,
        payCode4,
        localFlag4,
        partno4,
        qty4,
        partAmount4,
        multiprr4,
        payCode5,
        localFlag5,
        partno5,
        qty5,
        partAmount5,
        multiprr5,
        payCode6,
        localFlag6,
        partno6,
        qty6,
        partAmount6,
        multiprr6,

        operationNo,
        payCodeLabor1,
        operationNo1,
        hour1,
        payCodeLabor2,
        operationNo2,
        hour2,
        payCodeLabor3,
        operationNo3,
        hour3,

        payCodeSublet1,
        subletType1,
        invoice1,
        amount1,
        subletDescription1,
        payCodeSublet2,
        subletType2,
        invoice2,
        amount2,
        subletDescription2,

        condition,
        cause,
        remedy,
        fDisComment,

        evidence,

        warrantyApplicationCode1,
        warrantyApplicationCode2,
        warrantyApplicationCode3,
        warrantyApplicationCode4,
        warrantyApplicationCode5,

        batteryTestCodeCode1,
        batteryTestCodeCode2,
        batteryTestCodeCode3,
        batteryTestCodeCode4,

        diagnosticCode1,
        diagnosticCode2,
        diagnosticCode3,
        diagnosticCode4,
        diagnosticCode5,

        tsb,

        serialCode1,
        serialCode2,
        serialCode3,
      }) => {
        const itemReceive = String(receive).padStart(2, '0');
        const itemDistCode = String(distCode).padEnd(5, ' ');
        const itemTwcNo = String(twcNo).padStart(7, '0');
        const itemInitialProcessDate = String(
          transformDate(initialProcessDate)
        ).padEnd(8, ' ');
        const itemPage = entireNumberFormat(page, 2);
        const itemClaimantCode = String(claimantCode).padEnd(5, ' ');
        const itemFranchise = String(franchise).padEnd(1, ' ');
        const itemWarrantyType = String(warrantyType).padEnd(2, ' ');
        const itemDataId = String(dataId).padEnd(1, ' ');
        const itemNonVFlag = String(nonVFlag).padEnd(1, ' ');
        const itemOperationType = String(operationType).padEnd(1, ' ');
        const itemProcessDate = String(transformDate(processDate)).padEnd(
          8,
          ' '
        );
        const itemProcessFlag = String(processFlag).padEnd(1, ' ');
        const itemInvoiceNo = String(invoiceNo).padEnd(7, ' ');
        const itmeDealerCode = String(dealerCode).padEnd(10, ' ');
        const itemDealerClaimNo = String(dealerClaimNo).padStart(6, ' ');
        const itemCurrency = String(currency).padEnd(1, ' ');
        const itemExchangeRate = ruleThreeFormat(exchangeRate, 3, 4);
        const itemPrr1 = quantityFormat(prr1, 2, 3);
        const itemLaborRate = quantityFormat(LaborRate, 5, 2);
        const itemT1Code = String(t1Code).padEnd(2, ' ');
        const itemT2Code = String(t2Code).padEnd(2, ' ');
        const itemWmi = String(wmi).padEnd(3, ' ');
        const itemVds = String(vds).padEnd(5, ' ');
        const itemCd = String(cd).padEnd(1, ' ');
        const itemVis = String(vis).padEnd(8, ' ');

        const itemT3_1 = String(t3_1).padEnd(5, ' ');
        const itemT3_2 = String(t3_2).padEnd(5, ' ');
        const itemT3_3 = String(t3_3).padEnd(5, ' ');
        const itemT3_4 = String(t3_4).padEnd(5, ' ');
        const itemT3_5 = String(t3_5).padEnd(5, ' ');
        const itemT3_6 = String(t3_6).padEnd(5, ' ');
        const itemT3_7 = String(t3_7).padEnd(5, ' ');

        const itemRepairOpenDate = String(transformDate(repairOpenDate)).padEnd(
          8,
          ' '
        );
        const itemRepairCompletionDate = String(
          transformDate(repairCompletionDate)
        ).padEnd(8, ' ');
        const itemDeliveryDate = String(transformDate(deliveryDate)).padEnd(
          8,
          ' '
        );
        const itemMileage = entireNumberFormat(mileage, 6);
        const itemKm = String(km).padEnd(1, ' ');
        const itemRepairOrderNo = String(repairOrderNo).padEnd(10, ' ');
        // TO-DO: Solicitar que no retornen NULL del Backend
        const itemPrevRepairOrderNo = String(previousRepairOrderNo).padEnd(
          10,
          ' '
        );
        const itemPrevRepairCompletionDate = String(
          transformDate(previousRepairCompletionDate)
        ).padEnd(8, ' ');

        const itemAccFstInsDate = String(transformDate(accFstInsDate)).padEnd(
          8,
          ' '
        );

        const itemAccFstInsMileage = accFstInsMileage !== ' ' ? entireNumberFormat(accFstInsMileage, 6) : '';
        const itemPrevRepairMileage = previousRepairMileage !== ' ' ? entireNumberFormat(previousRepairMileage, 6) : '';

        const itemPrevInvoiceNo = String(previousInvoiceNo).padEnd(7, ' ');
        const itemCurrentInvoiceNo = String(currentInvoiceNo).padEnd(7, ' ');

        const itemAmountPartTotal = ruleThreeFormat(amountPartTotal, 7, 2);
        const itemLaborHourTotal = laborHourTotal === 0 ? 0 : ruleThreeFormat(laborHourTotal, 7, 2);
        const itemAmountLaborTotal = amountLaborTotal === 0 ? 0 : ruleThreeFormat(amountLaborTotal, 7, 2);
        const itemAmountSubletTotal = ruleThreeFormat(amountSubletTotal, 7, 2);
        const itemAmountGrantTotal = ruleThreeFormat(amountGrantTotal, 7, 2);

        const itemPart = entireNumberFormat(part, 3);
        const itemLabor = entireNumberFormat(labor, 3);
        const itemSublet = entireNumberFormat(sublet, 3);

        const itemOfpLocalFlag = String(ofpLocalFlag).padEnd(1, ' ');
        const itemOfp = String(ofp).padEnd(15, ' ');

        const itemPayCode1 = String(payCode1).padEnd(1, ' ');
        const itemLocalFlag1 = String(localFlag1).padEnd(1, ' ');
        const itemPartNo1 = String(partno1).padEnd(15, ' ');
        const itemQty1 = entireNumberFormat(qty1, 3);
        const itemPartAmount1 = ruleThreeFormat(partAmount1, 7, 2);
        const itemMultiPrr1 = quantityFormat(multiprr1, 3, 2);
        const itemPayCode2 = String(payCode2).padEnd(1, ' ');
        const itemLocalFlag2 = String(localFlag2).padEnd(1, ' ');
        const itemPartNo2 = String(partno2).padEnd(15, ' ');
        const itemQty2 = entireNumberFormat(qty2, 3);
        const itemPartAmount2 = ruleThreeFormat(partAmount2, 7, 2);
        const itemMultiPrr2 = quantityFormat(multiprr2, 3, 2);
        const itemPayCode3 = String(payCode3).padEnd(1, ' ');
        const itemLocalFlag3 = String(localFlag3).padEnd(1, ' ');
        const itemPartNo3 = String(partno3).padEnd(15, ' ');
        const itemQty3 = entireNumberFormat(qty3, 3);
        const itemPartAmount3 = ruleThreeFormat(partAmount3, 7, 2);
        const itemMultiPrr3 = quantityFormat(multiprr3, 3, 2);
        const itemPayCode4 = String(payCode4).padEnd(1, ' ');
        const itemLocalFlag4 = String(localFlag4).padEnd(1, ' ');
        const itemPartNo4 = String(partno4).padEnd(15, ' ');
        const itemQty4 = entireNumberFormat(qty4, 3);
        const itemPartAmount4 = ruleThreeFormat(partAmount4, 7, 2);
        const itemMultiPrr4 = quantityFormat(multiprr4, 3, 2);
        const itemPayCode5 = String(payCode5).padEnd(1, ' ');
        const itemLocalFlag5 = String(localFlag5).padEnd(1, ' ');
        const itemPartNo5 = String(partno5).padEnd(15, ' ');
        const itemQty5 = entireNumberFormat(qty5, 3);
        const itemPartAmount5 = ruleThreeFormat(partAmount5, 7, 2);
        const itemMultiPrr5 = quantityFormat(multiprr5, 3, 2);
        const itemPayCode6 = String(payCode6).padEnd(1, ' ');
        const itemLocalFlag6 = String(localFlag6).padEnd(1, ' ');
        const itemPartNo6 = String(partno6).padEnd(15, ' ');
        const itemQty6 = entireNumberFormat(qty6, 3);
        const itemPartAmount6 = ruleThreeFormat(partAmount6, 7, 2);
        const itemMultiPrr6 = quantityFormat(multiprr6, 3, 2);

        const itemOperationNo = String(operationNo).padEnd(10, ' ');
        const itemPayCodeLabor1 = String(payCodeLabor1).padEnd(1, ' ');
        const itemOperationNo1 = String(operationNo1).padEnd(10, ' ');
        const itemHour1 = hour1 === 0 ? 0 : ruleThreeFormat(hour1, 3, 1);
        const itemPayCodeLabor2 = String(payCodeLabor2).padEnd(1, ' ');
        const itemOperationNo2 = String(operationNo2).padEnd(10, ' ');
        const itemHour2 = hour2 === 0 ? 0 : ruleThreeFormat(hour2, 3, 1);
        const itemPayCodeLabor3 = String(payCodeLabor3).padEnd(1, ' ');
        const itemOperationNo3 = String(operationNo3).padEnd(10, ' ');
        const itemHour3 = hour3 === 0 ? 0 : ruleThreeFormat(hour3, 3, 1);

        const itemPayCodeSublet1 = String(payCodeSublet1).padEnd(1, ' ');
        const itemSubletType1 = String(subletType1).padEnd(2, ' ');
        const itemInvoice1 = String(invoice1).padEnd(7, ' ');
        const itemAmount1 = ruleThreeFormat(amount1, 7, 2);
        const itemSubletDescription1 = String(subletDescription1).padEnd(
          50,
          ' '
        );
        const itemPayCodeSublet2 = String(payCodeSublet2).padEnd(1, ' ');
        const itemSubletType2 = String(subletType2).padEnd(2, ' ');
        const itemInvoice2 = String(invoice2).padEnd(7, ' ');
        const itemAmount2 = ruleThreeFormat(amount2, 7, 2);
        const itemSubletDescription2 = String(subletDescription2).padEnd(
          50,
          ' '
        );

        const itemCondition = String(condition).padEnd(75, ' ');
        const itemCause = String(cause).padEnd(75, ' ');
        const itemRemedy = String(remedy).padEnd(75, ' ');
        const itemFDisComment = String(fDisComment).padEnd(75, ' ');

        const itemEvidence = String(evidence).padEnd(1, ' ');

        const itemWAPPCode1 = String(warrantyApplicationCode1).padEnd(1, ' ');
        const itemWAPPCode2 = String(warrantyApplicationCode2).padEnd(1, ' ');
        const itemWAPPCode3 = String(warrantyApplicationCode3).padEnd(1, ' ');
        const itemWAPPCode4 = String(warrantyApplicationCode4).padEnd(1, ' ');
        const itemWAPPCode5 = String(warrantyApplicationCode5).padEnd(1, ' ');

        const itemBatteryTestCode1 = String(batteryTestCodeCode1).padEnd(
          20,
          ' '
        );
        const itemBatteryTestCode2 = String(batteryTestCodeCode2).padEnd(
          20,
          ' '
        );
        const itemBatteryTestCode3 = String(batteryTestCodeCode3).padEnd(
          20,
          ' '
        );
        const itemBatteryTestCode4 = String(batteryTestCodeCode4).padEnd(
          20,
          ' '
        );

        const itemDiagnCode1 = String(diagnosticCode1).padEnd(10, ' ');
        const itemDiagnCode2 = String(diagnosticCode2).padEnd(10, ' ');
        const itemDiagnCode3 = String(diagnosticCode3).padEnd(10, ' ');
        const itemDiagnCode4 = String(diagnosticCode4).padEnd(10, ' ');
        const itemDiagnCode5 = String(diagnosticCode5).padEnd(10, ' ');

        const itemTsb = String(tsb).padEnd(20, ' ');

        const itemSerialCode1 = String(serialCode1).padEnd(30, ' ');
        const itemSerialCode2 = String(serialCode2).padEnd(30, ' ');
        const itemSerialCode3 = String(serialCode3).padEnd(30, ' ');

        let line = `${itemReceive},${itemDistCode},${itemTwcNo},${itemInitialProcessDate},`;
        line = `${line}${itemPage},${itemClaimantCode},${itemFranchise},${itemWarrantyType},`;
        line = `${line}${itemDataId},${itemNonVFlag},${itemOperationType},${itemProcessDate},`;
        line = `${line}${itemProcessFlag},${itemInvoiceNo},${itmeDealerCode},${itemDealerClaimNo},`;
        line = `${line}${itemCurrency},${itemExchangeRate},${itemPrr1},${itemLaborRate},`;
        line = `${line}${itemT1Code},${itemT2Code},${itemWmi},${itemVds},${itemCd},${itemVis},`;

        line = `${line}${itemT3_1},${itemT3_2},${itemT3_3},${itemT3_4},${itemT3_5},${itemT3_6},${itemT3_7},`;

        line = `${line}${itemRepairOpenDate},${itemRepairCompletionDate},${itemDeliveryDate},${itemMileage},`;
        line = `${line}${itemKm},${itemRepairOrderNo},${itemPrevRepairOrderNo},${itemPrevRepairCompletionDate},`;

        line = `${line}${itemAccFstInsDate},${itemAccFstInsMileage},${itemPrevRepairMileage},`;
        line = `${line}${itemPrevInvoiceNo},${itemCurrentInvoiceNo},`;

        line = `${line}${itemAmountPartTotal},${itemLaborHourTotal},${itemAmountLaborTotal},`;
        line = `${line}${itemAmountSubletTotal},${itemAmountGrantTotal},`;
        line = `${line}${itemPart},${itemLabor},${itemSublet},`;

        line = `${line}${itemOfpLocalFlag},${itemOfp},`;

        line = `${line}${itemPayCode1},${itemLocalFlag1},${itemPartNo1},${itemQty1},${itemPartAmount1},${itemMultiPrr1},`;
        line = `${line}${itemPayCode2},${itemLocalFlag2},${itemPartNo2},${itemQty2},${itemPartAmount2},${itemMultiPrr2},`;
        line = `${line}${itemPayCode3},${itemLocalFlag3},${itemPartNo3},${itemQty3},${itemPartAmount3},${itemMultiPrr3},`;
        line = `${line}${itemPayCode4},${itemLocalFlag4},${itemPartNo4},${itemQty4},${itemPartAmount4},${itemMultiPrr4},`;
        line = `${line}${itemPayCode5},${itemLocalFlag5},${itemPartNo5},${itemQty5},${itemPartAmount5},${itemMultiPrr5},`;
        line = `${line}${itemPayCode6},${itemLocalFlag6},${itemPartNo6},${itemQty6},${itemPartAmount6},${itemMultiPrr6},`;

        line = `${line}${itemOperationNo},${itemPayCodeLabor1},${itemOperationNo1},${itemHour1},`;
        line = `${line}${itemPayCodeLabor2},${itemOperationNo2},${itemHour2},${itemPayCodeLabor3},`;
        line = `${line}${itemOperationNo3},${itemHour3},`;

        line = `${line}${itemPayCodeSublet1},${itemSubletType1},${itemInvoice1},${itemAmount1},`;
        line = `${line}${itemSubletDescription1},${itemPayCodeSublet2},${itemSubletType2},${itemInvoice2},`;
        line = `${line}${itemAmount2},${itemSubletDescription2},`;

        line = `${line}${itemCondition},${itemCause},${itemRemedy},${itemFDisComment},`;

        line = `${line}${itemEvidence},`;

        line = `${line}${itemWAPPCode1},${itemWAPPCode2},${itemWAPPCode3},${itemWAPPCode4},${itemWAPPCode5},`;

        line = `${line}${itemBatteryTestCode1},${itemBatteryTestCode2},${itemBatteryTestCode3},${itemBatteryTestCode4},`;

        line = `${line}${itemDiagnCode1},${itemDiagnCode2},${itemDiagnCode3},${itemDiagnCode4},${itemDiagnCode5},`;

        line = `${line}${itemTsb},`;

        line = `${line}${itemSerialCode1},${itemSerialCode2},${itemSerialCode3}`;

        line = `${line}\n`;
        result = result + line;
      }
    );
  }
  return result;
}

export const createContent = (items) => {
  const content = createDetail(items);
  return `${content}`;
};

export const downloadFile = (fileData) => {
  const content = createContent(fileData);
  if (content !== null) {
    const element = document.createElement('a');
    const file = new Blob([content], {'type': 'text/csv'});
    element.href = URL.createObjectURL(file);
    element.download = 'PROCESSED_WARRANTIES.csv';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  } else {
    this.props.addMessageBoxError(
      'Error, faltan datos para generar el documento'
    );
  }
};

export const validateFinalTwc = (data) => {
  if (data.length === 0) {
    return false;
  }
  const invalidItem = data.filter(
    (element) => !!element.twcNumDefinitive && element.twcNumDefinitive !== ''
  );
  return invalidItem && invalidItem.length > 0 ? true : false;
};

export const parseStatus = (warrantyStatus) => {
  const statusSelect = warrantyStatus.map((item) => ({
    'key': item.status,
    'text': item.description.toUpperCase(),
    'value': item.status,
  }));
  statusSelect.unshift({'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'});
  return statusSelect;
};

export const buildParameters = (filters) => {
  const {
    dealer,
    initDate,
    endDate,
    typeTwc,
    status,
    katashiki,
    invoice,
    account,
    campaignNo,
    tasks,
    OFP,
    reportType,
  } = filters;

  const parameters = {
    'initDate': initDate ? moment(initDate).format(reverseShortDate) : null,
    'endDate': endDate ? moment(endDate).format(reverseShortDate) : null,
    dealer,
    typeTwc,
    status,
    katashiki,
    campaignNo,
    invoice,
    account,
    tasks,
    OFP,
    reportType,
  };

  Object.keys(parameters).forEach((key) => {
    const value = parameters[key];
    if (!value || (Array.isArray(value) && !value?.length)) {
      delete parameters[key];
    }
  });

  return parameters;
};


export const parseCarModels = (partCarModels = []) => {
  const parseModels = [];
  partCarModels.forEach((item) => {
    const model = item.katashiki.split('-')[0];

    if (!parseModels.some((element) => element.value === model)) {
      const newModel = {
        'text': `${model}`,
        'value': model,
      };

      parseModels.push(newModel);
    }
  });
  return parseModels;
};

export const parseParts = (partsList = []) => {
  return partsList.map((item, index) => ({
    'text': `${item.code}  |  ${item.name}`,
    'value': item.code,
  }));
};

export const parseTasks = (tasksList = []) => {
  return tasksList.map((item) => ({
    'key': item.id,
    'text': `${item.id}  |  ${item.description}`,
    'value': encodeURIComponent(item.id),
  }));
};

export const addSelectedTasks = (tasks, selectedTasks) => {
  const totalTasks = tasks.concat(selectedTasks);
  if (tasks.length !== selectedTasks.length) {
    return selectedTasks;
  }

  return totalTasks;
};

const parseNumberRawValue = (value) => {
  if (!isNaN(value) && isNumber(value)) {
    return value;
  }

  return 0;
};

const parseRawStringValue = (value) => {
  if (value && isString(value)) {
    return value.trim().toUpperCase();
  }
  return '';
};

export const parseWarrantyInvoicingFileData = (data) => {
  return data
    .filter((item) => item[1])
    .map((item) => ({
      'numTwcDealer': parseRawStringValue(item[1]),
      'order': parseRawStringValue(item[2]),
      'totalTwc': parseNumberRawValue(item[9]),
      'totalsDetail': {
        'jobsDealer': parseNumberRawValue(item[6]),
        'partsDealer': parseNumberRawValue(item[7]),
        'subcontDealer': parseNumberRawValue(item[8]),
      },
    }));
};

export const getHeaderValues = (header) => {
  const detail = header[0];
  const invoiceIndex = detail.indexOf('#');
  const invoice = detail.substring(invoiceIndex + 1);
  return invoice.trim();
};

export const getRowValue = (row) => {
  if (row && row.original) {
    const invalidRecord = (row.original && row.original.invalid);
    const updatedRecord = (row.original && row.original.updated);

    if (invalidRecord) {
      return {
        'style': {
          'color': '#9f3a38',
          'background': '#fff6f6',
        },
      };
    }
    if (updatedRecord) {
      return {
        'style': {
          'color': '#573a08',
          'background': '#fffaf3',
        },
      };
    }
  }

  return {};
};

export const flatInputData = (data) => {
  return data.map((element) => {
    const {jobsDiff, subcontDiff, partsDiff} = element.totalsDetail;
    return {
      ...element,
      'jobsDiff': isNumber(jobsDiff) ? jobsDiff : '-',
      'subcontDiff': isNumber(subcontDiff) ? subcontDiff : '-',
      'partsDiff': isNumber(partsDiff) ? partsDiff : '-',
    };
  });
};
